enum ProductBasketLineItemMarkerEnum {
  Null = '',
  Hazardous = '2',
  Clearance = 'C',
}

export default ProductBasketLineItemMarkerEnum;
